/* global cURL */
export class KeepAlive {
  #interval = 30000;
  #timeoutId;

  constructor(interval) {
    if (interval) this.#interval = interval;
    this.#bindEvents();
    this.#startTimeout();
  }

  #sendKeepAlive = () => {
    fetch(`${cURL}mwork/ajax/keep-alive.html`, { method: 'POST' })
      .catch(error => console.error('KeepAlive request failed:', error));
  };

  #startTimeout() {
    this.#timeoutId = setTimeout(this.#sendKeepAlive, this.#interval);
  }

  #resetTimeout() {
    clearTimeout(this.#timeoutId);
    this.#startTimeout();
  }

  #handleActivity = () => {
    this.#resetTimeout();
  };

  #bindEvents() {
    document.addEventListener('change', this.#handleActivity);
    document.addEventListener('click', this.#handleActivity);
    document.addEventListener('keyup', this.#handleActivity);
  }
}

